import axios from "axios";
import { siteSettings } from "../static";

export async function uploadImageToCloudinary(file, options = {}) {
  const { onUploadProgress } = options;
  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", siteSettings.uploadPreset);

  const response = await axios.post(
    `https://api.cloudinary.com/v1_1/${siteSettings.cloudName}/image/upload`,
    formData,
    onUploadProgress ? { onUploadProgress } : undefined
  );

  return response.data.secure_url;
}
